import { render, staticRenderFns } from "./network.vue?vue&type=template&id=1f8bbbbb&scoped=true&"
import script from "./network.vue?vue&type=script&lang=js&"
export * from "./network.vue?vue&type=script&lang=js&"
import style0 from "./network.vue?vue&type=style&index=0&id=1f8bbbbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8bbbbb",
  null
  
)

export default component.exports